/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */
import {SET_CURRENT_THEME} from "../../qwc2/actions/theme";

export function setTheme(theme, layer) {
    return {
        type: SET_CURRENT_THEME,
        theme: theme,
        layer: layer
    };
}
